(function () {
    'use strict';

    angular
        .module('app')
        .controller('MusiciansController', MusiciansController);

    MusiciansController.$inject = ['$http', '$stateParams', '$rootScope', '$timeout', '$state', 'cache', '$q', 'authenticator', '$scope', 'localization'];

    function MusiciansController($http, $stateParams, $rootScope, $timeout, $state, cache, $q, authenticator, $scope, localization) {
        $rootScope.header_inverted = true;
        $rootScope.on_dashboard = false;
        $rootScope.separate_page = false;
        $rootScope.dark_text_header = true;
        var vm = this;
        vm.resultsPerPage = 18;
        vm.$onInit = init;
        vm.page = 1;
        vm.musicians = [];
        vm.freetext = "";
        vm.searchString = "";
        vm.sortBy = "relevance";
        vm.dateRangeStart = new Date();
        vm.activeFilters = 0;
        vm.showAllConcertPrices = true;
        vm.selected_genres = [];
        vm.locations = [];
        vm.getMusicians = getMusicians;
        vm.getSelectedGenres = getSelectedGenres;
        vm.getSelectedLocations = getSelectedLocations;
        vm.getSelectedStatuses = getSelectedStatuses;
        vm.selectGenre = selectGenre;
        vm.selectLocation = selectLocation;
        vm.selectStatus = selectStatus;
        vm.search = search;
        vm.searchBlur = searchBlur;
        vm.searchInputFocus = searchInputFocus;
        vm.searchOnEnter = searchOnEnter;
        vm.clearText = clearText;
        vm.clearSearchAndFilters = clearSearchAndFilters;
        vm.clearGenreFilter = clearGenreFilter;
        vm.clearLocationFilter = clearLocationFilter;
        vm.toggleFilterSort = toggleFilterSort;
        vm.toggleLocationFilter = toggleLocationFilter;
        vm.toggleGenreFilter = toggleGenreFilter;
        vm.toggleMoreFilter = toggleMoreFilter;
        vm.toggleSortFilter = toggleSortFilter;
        vm.toggleSearchFilter = toggleSearchFilter;
        vm.changeLocation = changeLocation;
        vm.countActiveLocationFilters = countActiveLocationFilters;
        vm.countActiveMoreFilters = countActiveMoreFilters;
        vm.countActiveMobileFilters = countActiveMobileFilters;
        vm.closeFilters = closeFilters;
        vm.updatePage = updatePage;
        vm.navigateToMusician = navigateToMusician;
        vm.favourite = favourite;
        vm.togglePrivateConcertView = togglePrivateConcertView;
        vm.selectBookingLevel = selectBookingLevel;
        vm.toggleShowAllConcertPrices = toggleShowAllConcertPrices;
        vm.statuses = [
            { status: "All-Star", statusSlug: "all_star" },
            { status: "New", statusSlug: "new" }
        ];

        $scope.$on('$destroy', function () {
            $rootScope.dark_text_header = false;
        });

        function init() {
            window.document.title = $stateParams.language == 'da' ? "Artister – Be My Concert" : "Musicians – Be My Concert";
            vm.musicians = [];
            vm.bookingLevels = [];
            getLoggedIn();
            getGenres().then(function () {
                getCountryRegions();
            });
            localization.getLocation().then(function(response) {
                vm.currency = localization.getCurrency();
                vm.location = response;
                if(vm.location != "Denmark") {
                    vm.hide_city_search = true;
                }
                if (cache.exists('genres') && cache.exists('bookingLevels')) {
                    vm.genres = cache.load('genres');
                    vm.bookingLevels = cache.load('bookingLevels');
                    setFilterFromState();
                    getMusicians();
                } else {
                        $q.all([
                            getBookingLevels(),
                            getGenres()
                        ]).then(function () {
                            setFilterFromState();
                            getMusicians();
                        });

                }
            });
        }

        function getLoggedIn() {
            authenticator.checkLoginStatus()
                .then(function (isLoggedIn) {
                    vm.logged_in = isLoggedIn;
                });
        }

        function toggleShowAllConcertPrices() {
            vm.showAllConcertPrices = !vm.showAllConcertPrices;
            if (vm.showAllConcertPrices) {
                vm.bookingLevels.forEach(function (bookingLevel) {
                    bookingLevel.selected = false;
                });
            }
            setFilterState();
            search();
        }

        function selectBookingLevel(bookingLevel) {
            bookingLevel.selected = !bookingLevel.selected;
            if (bookingLevel.selected) {
                vm.showAllConcertPrices = false;
            } else {
                var anySelected = false;
                vm.bookingLevels.forEach(function (bookingLevel) {
                    if (bookingLevel.selected) {
                        anySelected = true;
                    }
                });
                vm.showAllConcertPrices = !anySelected;
            }
            setFilterState();
            search();
        }

        function getBookingLevels() {
            $http.get('api/booking_levels/' + vm.currency)
                .then(function (response) {
                    vm.bookingLevels = response.data;
                    cache.save('bookingLevels', vm.bookingLevels);
                })
        }

        function getCountryRegions() {
            if($stateParams.location_filter){
                vm.locationFilter = $stateParams.location_filter;
            }
            if(!cache.exists('bandCountryRegions')){
                $http.get('api/band_country_regions/')
                .then(function (response) {
                    vm.allCountryRegions = response.data;
                    cache.save('bandCountryRegions', vm.allCountryRegions);
                    setCountryRegions();
                })
                .then(function (response) {
                    setFilterFromState();
                })
                .then(function (response) {
                   getMusicians();
                });
            } else {
                loadRegionsFromCache();
                setFilterFromState();
                getMusicians();
            }
        }

        function loadRegionsFromCache() {
            vm.allCountryRegions = cache.load('bandCountryRegions');
            setCountryRegions();
        }

        function setCountryRegions(location) {
            if(location == 'DK' || location == 'SE'){
                vm.countryRegions = vm.allCountryRegions.filter(function(countryRegion) {
                    return countryRegion.country_iso_code == location;
                });
                vm.locations = vm.countryRegions;
            } if(vm.locationFilter == 'all') {
                vm.locations = [];
            }
        }

        function togglePrivateConcertView() {
            vm.privateConcertView = !vm.privateConcertView;
            setFilterState();
            search();
        }

        function favourite(e, musician) {
            e.preventDefault();
            e.stopPropagation();
            if (!vm.logged_in) {
                var backState = angular.copy($stateParams);
                return $state.go('login', { 'backToStateName': 'musicians', 'backToStateParams': backState });
            } else {
                musician['favorite'] = !musician['favorite'];
                musician.is_favorite = !musician.is_favorite;
                $scope.$applyAsync();
                $http.patch('api/favorite_band/' + musician.band_slug + '/')
                .then(function (response) {
                    getMusicians(1);
                });
            }
        }

        function changeLocation(location) {
            vm.locations.forEach(function (location) {
                location.selected = false;
            });
            setCountryRegions(location);
            search();
        }

        function navigateToMusician(musician) {
            cache.save('scrollY', window.scrollY);
        }

        function updatePage(page) {
            if (page > 0 && page <= Math.ceil(parseInt(vm.allResultsCount) / vm.resultsPerPage)) {
                vm.page = page;
                getMusicians();
                setFilterState();
            }
        }

        function clearSearchAndFilters() {
            vm.genres.forEach(function (genre) {
                genre.selected = false;
            });
            vm.locations.forEach(function (location) {
                location.selected = false;
            });
            vm.statuses.forEach(function (status) {
                status.selected = false;
            });
            vm.bookingLevels.forEach(function (bookingLevel) {
                bookingLevel.selected = false;
            });
            vm.showAllConcertPrices = true;
            vm.freetext = '';
            vm.showSearchResults = false;
            vm.locationFilter = "all";
            vm.locations = [];
            vm.sortBy = "relevance";
            // setActiveFilters();
            setFilterState();
            search();
        }

        function clearGenreFilter() {
            vm.genres.forEach(function (genre) {
                genre.selected = false;
            });
            // setActiveFilters();
            setFilterState();
            search();
        }

        function clearLocationFilter() {
            vm.locations.forEach(function (location) {
                location.selected = false;
            });
            // setActiveFilters();
            setFilterState();
            search();
        }

        function clearText() {
            vm.freetext = '';
            vm.showSearchResults = false;
            vm.showSearch = false;
            if (cache.load('searchData').freetext != "") {
                search();
            }
        }

        function searchBlur(event) {
            if (vm.freetext != '') {
                setTimeout(function () { vm.searchFocus = false; }, 0);
            } else {
                vm.searchFocus = false;
            }
        }

        function searchOnEnter(event){
            if (event.keyCode == 13){
                search();
            }
        }

        function searchInputFocus(elementID){
            vm.showSearch = !vm.showSearch;
            vm.searchFocus = true;
            var element = document.getElementById(elementID);
            setTimeout(function(){
                element.focus();
            }, 200);
        }

        function setFilterFromState() {
            if ($stateParams.genre != 'any') {
                var URIgenres = decodeURI($stateParams.genre).split(';');
                vm.genres.forEach(function (genre) {
                    URIgenres.forEach(function (URIGenre) {
                        if (genre.filter_value_name == URIGenre) {
                            genre.selected = true;
                        }
                    });
                });
            }
            if ($stateParams.location != 'any') {
                var URIlocations = decodeURI($stateParams.location).split(';');
                vm.locations.forEach(function (location) {
                    URIlocations.forEach(function (URILocation) {
                        if (location.country_region_name == URILocation) {
                            location.selected = true;
                        }
                    });
                });
            }
            if ($stateParams.status != '') {
                var URIStatuses = decodeURI($stateParams.status).split(';');
                vm.statuses.forEach(function (status) {
                    URIStatuses.forEach(function (URIStatus) {
                        if (status.statusSlug == URIStatus) {
                            status.selected = true;
                        }
                    });
                });
            }
            if ($stateParams.page != '1') {
                vm.page = $stateParams.page;
            }
            vm.sortBy = $stateParams.sort;
            vm.freetext = $stateParams.search;
            vm.locationFilter = $stateParams.location_filter;
            vm.privateConcertView = $stateParams.private == 'private';
            if ($stateParams.booking_levels) {
                var booking_levels = [];
                if (typeof $stateParams.booking_levels == "string") { //if theres only a single booking level in the state it resolves as a string instead of array
                    booking_levels = [$stateParams.booking_levels];
                } else {
                    booking_levels = $stateParams.booking_levels;
                }
                booking_levels.forEach(function (selectedBookingLevel) {
                    vm.bookingLevels.forEach(function (bookingLevel) {
                        if (bookingLevel.booking_level_id == selectedBookingLevel) {
                            bookingLevel.selected = true;
                        }
                    })
                });
                vm.showAllConcertPrices = false;
            }
            // setActiveFilters()
        }

        function setFilterState() {
            var params = JSON.parse(JSON.stringify($stateParams));
            if (getSelectedGenres().length > 0) {
                var uriString = '';
                getSelectedGenres().forEach(function (genre) {
                    if (uriString.length > 0) uriString += ';';
                    uriString += encodeURI(genre.filter_value_name);
                });
                params.genre = uriString;
            } else {
                params.genre = 'any';
            }
            if (getSelectedLocations().length > 0) {
                var uriString = '';
                getSelectedLocations().forEach(function (location) {
                    if (uriString.length > 0) uriString += ';';
                    uriString += encodeURI(location.country_region_name);
                });
                params.location = uriString;
            } else {
                params.location = 'any';
            }
            if (getSelectedStatuses().length > 0) {
                var uriString = '';
                getSelectedStatuses().forEach(function (status) {
                    if (uriString.length > 0) uriString += ';';
                    uriString += encodeURI(status.statusSlug);
                });
                params.status = uriString;
            } else {
                params.status = 'all';
            }
            params.page = vm.page;
            params.sort = vm.sortBy;
            params.search = vm.freetext;
            params.location_filter = vm.locationFilter;
            params.private = vm.privateConcertView ? 'private' : '';
            params.booking_levels = getSelectedPriceRangeIds();
            // params.location = getSelectedLocations();
            var scrollY = window.scrollY;

            $state.transitionTo(
                'musicians',
                params,
                {
                    location: "replace", // This makes it update URL
                    inherit: true,
                    relative: $state.$current,
                    notify: false // This makes it not reload
                }
            ).then(function () {
                setTimeout(function () {
                    window.scrollTo(0, scrollY);
                }, 0);
            });
        }

        function countActiveLocationFilters() {
            var count = 0;
            count += vm.getSelectedLocations().length;
            if (vm.locationFilter == 'SE' || vm.locationFilter == 'DK'){
                count ++;
            }
            return count;
        }

        function countActiveMoreFilters() {
            var count = 0;
            count += getSelectedBookingRanges().length;
            count += getSelectedStatuses().length;
            return count;
        }

        function countActiveMobileFilters() {
            var count = 0;
            count += getSelectedGenres().length;
            count += countActiveMoreFilters();
            return count;
        }

        function getSelectedGenres() {
            if (!vm.genres) return [];
            var selectedGenres = [];
            vm.genres.forEach(function (genre) {
                if (genre.selected) {
                    selectedGenres.push(genre)
                }
            });
            return selectedGenres;
        }

        function getSelectedLocations() {
            if (!vm.locations) return [];
            var selectedLocations = [];
            vm.locations.forEach(function (location) {
                if (location.selected) {
                    selectedLocations.push(location)
                }
            });
            return selectedLocations;
        }

        function getSelectedPriceRangeIds() {
            var booking_level_ids = [];
            vm.bookingLevels.forEach(function (bookingLevel) {
                if (bookingLevel.selected)
                    booking_level_ids.push(bookingLevel.booking_level_id);
            });
            return booking_level_ids;
        }

        function getSelectedBookingRanges() {
            var booking_level_ids = [];
            vm.bookingLevels.forEach(function (bookingLevel) {
                if (bookingLevel.selected)
                    booking_level_ids.push(bookingLevel.booking_ranges);
            });
            return booking_level_ids;
        }

        function getSelectedStatuses() {
            var selectedStatuses = [];
            vm.statuses.forEach(status => {
                if (status.selected) selectedStatuses.push(status);
            });
            return selectedStatuses;
        }

        function selectGenre(genre) {
            genre.selected = !genre.selected;
            setFilterState();
            search();
        }

        function selectLocation(location) {
            location.selected = !location.selected;
            setFilterState();
            search();
        }

        function selectStatus(status) {
            status.selected = !status.selected;
            setFilterState();
            search();
        }

        function getGenres() {
            if (cache.exists('genres')) {
                vm.genres = cache.load('genres');
                return Promise.resolve();
            } else {
            return $http.get('api/genres/')
                .then(function (response) {
                    vm.genres = response.data;
                    cache.save('genres', vm.genres);
                });
            }
        }

        function toggleFilterSort() {
            vm.showFilterSort = !vm.showFilterSort;
            $rootScope.no_scroll = vm.showFilterSort;
        }

        function toggleLocationFilter() {
            vm.showLocation = !vm.showLocation;
            $rootScope.no_scroll = vm.showLocation;
        }

        function toggleGenreFilter() {
            vm.showGenre = !vm.showGenre;
            $rootScope.no_scroll = vm.showGenre;
        }

        function toggleMoreFilter() {
            vm.showMore = !vm.showMore;
            $rootScope.no_scroll = vm.showMore;
        }

        function toggleSortFilter() {
            vm.showSort = !vm.showSort;
            $rootScope.no_scroll = vm.showSort;
        }

        function toggleSearchFilter() {
            vm.showSearch = !vm.showSearch;
            $rootScope.no_scroll = vm.showSearch;
        }

        function closeFilters() {
            vm.showLocation = false;
            vm.showGenre = false;
            vm.showMore = false;
            vm.showSort = false;
            vm.showSearch = false;
            vm.showFilterSort = false;
            $rootScope.no_scroll = false;
        }

        function getMusicians(favourite) {
            var offset = (vm.page - 1) * vm.resultsPerPage;
            var data = {
                'genre': getSelectedGenres(),
                'freetext': vm.freetext,
                'limit': vm.resultsPerPage,
                'offset': offset,
                'sortby': vm.sortBy,
                'status': getSelectedStatuses(),
                'private': vm.privateConcertView,
                'postal_code': vm.city_search ? vm.city_search.postal_code_id : null,
                'price_ranges': getSelectedBookingRanges(),
                'location_filter': vm.locationFilter,
                'country_region': getSelectedLocations()
            }
            if (cache.exists('musicians') && cache.exists('searchData') && cache.equals('searchData', data) && !favourite) {
                vm.musicians = cache.load('musicians');
                vm.allResultsCount = cache.load('allResultsCount');
                updateViewState();
                if ($rootScope.previousURL.search('/musician/') != -1) {
                    setTimeout(function () {
                        window.scrollTo(0, cache.load('scrollY'));
                    }, 0);
                }
                return;
            }
            return $http.post('api/list/bands/', data)
                .then(function (response) {
                    vm.musicians = response.data.data;
                    vm.allResultsCount = response.data.all_results_count;
                    saveState(data, response.data.all_results_count);
                    updateViewState();
                    return vm.musicians;
                });
        }

        function updateViewState() {
            vm.searchString = vm.freetext != "" ? vm.freetext : "";
            if (vm.musicians.length == 0) {
                vm.showNoResults = true;
            } else {
                vm.showNoResults = false;

                if (vm.searchString != "") {
                    vm.showSearchResults = true;
                    vm.searchFocus = true;
                } else {
                    vm.showSearchResults = false;
                }
            }
        }

        function saveState(searchData, allResultsCount) {
            cache.save('searchData', searchData);
            cache.save('musicians', vm.musicians);
            cache.save('allResultsCount', allResultsCount);
        }

        function search() {
            vm.offset = 0;
            vm.allResultsCount = undefined;
            vm.page = 1;
            getMusicians();
            // setActiveFilters();
            setFilterState();
        }
        $scope.$watch('vm.city_search', function () {
            if(vm.city_search && vm.city_search.postal_code_id) {
                getMusicians();
            }
        });
    }
})();
